export const mergeURL = (...parts: string[]): string => parts.join('/')
